import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import { useSelector } from "react-redux";

export default function BlogDetails() {
  document.title = "Blog Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const blogId = location.state?.blogData?.data?.id;
  console.log(
    location.state?.blogData?.data?.id,
    "location.state?.blogData?.data?.id;"
  );
  const [blogData, setblogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);

  const [blogContent, setBlogContent] = useState("");

  const fetchblog = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.blog}/${id}`);
      setblogData(response?.data?.data);

      const htmlContent = response?.data?.data?.content?.htmlContent;

      setBlogContent(htmlContent);
    } catch (error) {
      console.error("Error fetching blog data:", error);
      setblogData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (blogId) {
      fetchblog(blogId);
    }
  }, [blogId]);

  const handleEditBlog = () => {
    if (blogData) {
      navigate(`/add-blog?blogId=${blogId}&gymId=${blogData.gymId}`);
    }
  };

  const handleDeleteBlog = async () => {
    try {
      await del(`${endpoints.blog}/${blogId}`);
      setblogData((prevData) => prevData.filter((blog) => blog.id !== blogId));
      toast.success("Blog Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate("/list-blog");
    } catch (error) {
      console.error("Error deleting Blog:", error);
    }
  };
  const { userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });
  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4 p-4">
          <Row className="justify-content-between align-items-center">
            <Col md={6}>
              <h2 className="fw-bold font-size-20 ff-sora primary-black">
                Blog Details
              </h2>
            </Col>
            <Col md={6} xs={12} className="d-flex justify-content-end">
              {userPermissions?.blog?.["Delete Blog"] && (
                <Button
                  color="white"
                  className="me-2 rounded-pill1"
                  onClick={() => setModalOpen(true)}
                >
                  Delete Blog
                </Button>
              )}
              {userPermissions?.blog?.["Update Blog"] && (
                <Button className="rounded-pill" onClick={handleEditBlog}>
                  Edit Blog
                </Button>
              )}
            </Col>
            <Modal
              isOpen={modalOpen}
              toggle={toggleModal}
              className="modal-dialog-centered rounded-4"
            >
              <ModalHeader
                toggle={toggleModal}
                className="font-size-16 fw-medium ff-sora"
              >
                Confirm Deletion
              </ModalHeader>
              <ModalBody className="font-size-14 fw-normal ff-sora">
                Are you sure you want to delete this blog?
              </ModalBody>
              <ModalFooter>
                <Button
                  type="submit"
                  className=" rounded-pill"
                  onClick={handleDeleteBlog}
                >
                  Confirm
                </Button>
                <Button
                  color="white"
                  className="rounded-pill1"
                  onClick={toggleModal}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          </Row>
          <Row className="mt-4">
            <Col xs="12" className="mb-3">
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={
                    blogData?.File
                      ? `${process.env.REACT_APP_IMG_URL}${blogData?.File}`
                      : null
                  }
                  alt="Profile"
                  className="object-fit-cover"
                  style={{
                    height: "100%",
                    maxHeight: "240px",
                    width: "100%",
                    maxWidth: "360px",
                    borderRadius: "12px",
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <span
                className="font-size-16 fw-bold ff-sora secondary-black"
                style={{ color: "#525252" }}
              >
                {blogData?.title}
              </span>

              <div dangerouslySetInnerHTML={{ __html: blogContent }}></div>
            </Col>
          </Row>
        </Card>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            height: "10px",
            position: "sticky",
            bottom: "0",
            zIndex: "10",
          }}
        ></div>
      </Container>
    </div>
  );
}
